<template>

  <div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <h2>
        <a href="#/after-sales">{{$t('afterSales.title')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{ $t('afterSales.favorites.title') }}
      </h2>

      <p>{{ $t('afterSales.favorites.description') }}</p>

      <div class="irinox-form after-sales" >

        <!-- <div v-for="fav in favorites" :key="fav.id">
          <div>{{ selectedLabel(fav) }}</div>
        </div> -->

        <!-- {{ favoritesEnhanced }} -->

        <DataTable v-if="favoritesEnhanced?.length > 0" :value="favoritesEnhanced" stripedRows
            responsiveLayout="stack"
            breakpoint="960px"
            :autoLayout="true" class="after-sales-table p-mt-4"
            rowGroupMode="subheader" groupRowsBy="domain"
            sortMode="multiple"  :multiSortMeta="[{field: 'domain', order: -1}, {field: 'level1Translation', order: 1}, {field: 'level2Translation', order: 1}, {field: 'level3Translation', order: 1}, {field: 'level4Translation', order: 1}, {field: 'level5Translation', order: 1}]">
            
            <template #groupheader="slotProps">
                <div class="domain-group-header">
                  {{ $t('afterSales.domain_'+(slotProps.data.domain.replace(" ", "_"))) }}
                </div>
            </template>
            
            <Column field="domain" header="DOMAIN"></Column>

            <Column v-for="index in 5" :field="'level' + index + 'Translation'" :key="index"></Column>

            <Column field="docTreeId">
              <template #body="slotProps">
                <div class="p-d-flex p-ai-center after-sales-datatable-buttons p-jc-end">
                  <i class="pi pi-external-link" @click="goTo(slotProps.data.docTreeId)"></i>
                  <i class="icon-trash" @click="removeFavorite(slotProps.data.docTreeId)"></i>
                </div>
              </template>
            </Column>

        </DataTable>

        <div v-else class="empty-list">
          {{ $t('afterSales.favorites.empty_list') }}
        </div>

      </div>

    </div>
  </div>

  <Toast />

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.dl_success" 
    mode="success" 
    :message="$t('afterSales.download_doc_success')"
    :life="3000" 
    @update:visible="dialog.dl_success = $event" />
  <IrinoxDialogDark :visible="dialog.up_success" 
    mode="success" 
    :message="$t('afterSales.upload_doc_success')"
    :life="3000" 
    @update:visible="dialog.up_success = $event" />


</template>

<script>
import { mapGetters } from 'vuex';
import AfterSalesService from '../../service/AfterSalesService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';

export default {
  components: { 
    IrinoxDialogDark
  },
  data() {
    return {
      dialog: {
        error: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      docTreeRaw: 'afterSales/docTreeRaw',
      favorites: 'afterSales/favorites',
    }),
    favoritesEnhanced() {
      let fv = [];
      this.favorites.forEach(fav => {
        let model = this.selectedModel(fav);
        if(model) {
          fv.push(model);
        }
      });
      return fv;
    },
  },
  watch: {
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  async mounted() { 
    if(this.docTreeRaw.length===0) {
      this.$router.push('/after-sales');
    }
    await this.loadFavorites();
  },
  methods: {
    async loadFavorites() {
      let response = await this.afterSalesService.getFavorites(this.personaltoken);
      if(response.code=="200") {
        this.$store.commit('afterSales/favorites', response.body);
      } else {
        console.error(JSON.stringify(response));
        this.$store.commit('afterSales/favorites', []);
        this.dialog.error = true;
      }
    },
    removeFavorite(docTreeId) {
      this.afterSalesService.deleteFavorite(this.personaltoken, docTreeId)
        .then((data) => {
          if(data.code=="200") {
            this.$store.commit('afterSales/favorites', data.body);
          } else {
            console.error(JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR "+error);
          this.dialog.error = true;
        });
    },
    selectedModel(docTreeId) {
      if(docTreeId) {
        return this.docTreeRaw.find(item => item.docTreeId == docTreeId);
      } else {
        return null;
      }
    },
    goTo(docTreeId) {
      this.$router.push('/after-sales/tree/'+docTreeId);
    },
    // selectedLabel(docTreeId) {
    //   let selected = this.selectedModel(docTreeId);
    //   if(selected) {
    //     let label = '';
    //     for(let i=1; i<=5; i++) {
    //       if(selected['level'+i]) {
    //         if(label) label += ' > ';
    //         label += selected['level'+i+'Translation'] || selected['level'+i];
    //       }
    //     }
    //     return label;
    //   }
    //   return 'UNKNOWN';
    // },
  }
}
</script>